export default __webpack_public_path__ + "static/media/Zone-5-Master-Plan-Type-D.2c2ed0c9.png";